import { useEffect } from 'react';
import i18n from '@/utils/i18n';

const APP_NAME = 'Vytal';

/**
 * Sets the document title with i18n support
 *
 * @param titleKey - Translation key for the page type (e.g., 'PageTitles:event')
 * @param entityName - Optional entity name to prepend (e.g., 'Summer Festival')
 *
 * Examples:
 * - useDocumentTitle('PageTitles:events') → "Events | Vytal"
 * - useDocumentTitle('PageTitles:event', event?.name) → "Summer Festival (Event) | Vytal"
 */
export function useDocumentTitle(titleKey: string, entityName?: string | null) {
  useEffect(() => {
    const translatedType = i18n.t(titleKey);

    if (entityName) {
      document.title = `${entityName} (${translatedType}) | ${APP_NAME}`;
    } else {
      document.title = `${translatedType} | ${APP_NAME}`;
    }

    return () => {
      document.title = APP_NAME;
    };
  }, [titleKey, entityName]);
}
